import { insertCommasIntoNumber } from '@trukt/portal-utils/insertCommasIntoNumber';
import { Typography } from '../../../../src/components/Typography';
import { SelectOption } from '../../inputs/selectOptions/SelectOption';
import { useStyles } from './PageSize.styles';

import { ORDER_TABLE_PAGE_SIZES } from './constants';
import { PageSizeProps } from './PageSize.types';
import { RenderWhen } from '../../RenderWhen';

export const PageSize = ({
  pageSize = 25,
  onPageSizeSelect = () => {},
  pageSizeOptions = ORDER_TABLE_PAGE_SIZES,
  totalRecords = 0,
  isInfinite = false,
}: PageSizeProps) => {
  const styles = useStyles();

  return (
    <div css={styles.root}>
      <Typography>Showing</Typography>

      <div>
        <SelectOption
          aria-label="Page Size"
          selectedValueId={pageSize}
          menuPlacement="top"
          options={pageSizeOptions}
          onChange={(newValue, actionMeta) => {
            if (actionMeta.action === 'select-option' && typeof newValue.value === 'number') {
              onPageSizeSelect(newValue.value);
            }
          }}
        />
      </div>

      <Typography className="w-16">
        <RenderWhen condition={!isInfinite}>of {insertCommasIntoNumber(totalRecords)}</RenderWhen>
      </Typography>
    </div>
  );
};
